export function Earth(){
    return(
        <div>
            <img className='earth-img' src='ASYSK1017_01.webp' alt='Earth' />
        </div>
    )
}